module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-music-icon-d92d053d96ece3796c2d939505f649a9.svg";